export default __webpack_public_path__ + "static/editorialnew-regular-ba7d00371b2c37019c9f0e800115f40b.woff";